module.exports = __webpack_public_path__ + "static/media/et.f306ee80.svg";